import { ConsolePage } from './pages/ConsolePage';
import './App.scss';

function App() {
  return (
    <div data-component="App">
      <ConsolePage />
    </div>
  );
}

export default App;
